import React, { useState } from 'react';
import './FAQ.css'
import pic19 from '../../assets/pic19.png'


const FAQs = (props) => {

     const [open, setOpen] = useState(false);

    const toggleFAQ = () => {
        setOpen(!open);
    };

    return ( 
        <nav className='faq-cont'> 
            <article className='part1-faq'>
                <h2 className='question'>{props.title}</h2>
              <button className={`circlebutton ${open ? 'open' : ''}`} onClick={toggleFAQ}>
                    <img src={pic19} alt='plus' />
                </button>
            </article>

                {open && <p className='answer'>{props.answer}</p>}
            <div className='line-faq'></div>
        </nav>
     );
}
 
export default FAQs;